import React from 'react';

function CheckmarkIconCustom(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill="#BFFD11" />
      <path
        fill="#00040F"
        fillRule="evenodd"
        d="M14.143 6.111a.75.75 0 01.246 1.032l-4.308 7a.75.75 0 01-1.19.116L6.2 11.342A.75.75 0 117.3 10.325l2.021 2.19 3.79-6.158a.75.75 0 011.031-.246z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default CheckmarkIconCustom;
